import {
  type PermissionRouteGuardData,
  PermissionRouteGuard,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { TaskManagementPageHeader } from '@exam-management/task-management';
import { Flex } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function TaskManagementLayout() {
  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/task-management/question-creation',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.VIEW],
    },
    {
      path: '/task-management/question-review',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_REVIEW.VIEW],
    },
    {
      path: '/task-management/qset-review',
      requiredPermission: [APP_PERMISSIONS.TASK.QSET_REVIEW.VIEW],
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
        <TaskManagementPageHeader />
        <Outlet />
      </Flex>
    </PermissionRouteGuard>
  );
}
